export const makeColumnsOnlineUsersDashboardIndicators = [
  { name: 'Organização', selector: 'organization' },
  { name: 'Usuários', selector: 'totalUsers' },
];
